export const constants = {
  graphScaleAutoValue: 9999,
};
